import datatables from '@/lang/languages/th/datatables';
import error from '@/lang/languages/th/error';
import orders from '@/lang/languages/th/orders';
import downtimeSelector from '@/lang/languages/th/downtimeSelector';
import reports from '@/lang/languages/th/reports';
import notify from '@/lang/languages/th/notify';
import settings from '@/lang/languages/th/settings';
import activities from '@/lang/languages/th/activities';
import downtimes from '@/lang/languages/th/downtimes';

export default {
  datatables,
  error,
  orders,
  downtimeSelector,
  reports,
  notify,
  settings,
  activities,
  downtimes,

  world: 'โลก',
  plant: 'โรงงาน',
  area: 'พื้นที่',
  areas: 'พื้นที่',
  line: 'เส้นผลิต',
  lines: 'เส้นผลิต',
  delete: 'ลบ',
  segment: 'ส่วน',
  machine: 'เครื่องจักร',
  machines: 'เครื่องจักร',
  element: 'องค์ประกอบ',
  map: 'แผนที่',
  issue: 'ปัญหา',
  typeOfIssue: 'ประเภทของปัญหา',
  currentShift: 'กะปัจจุบัน',
  noShift: 'ไม่มีกะ',
  currentOrder: 'คำสั่งปัจจุบัน',
  currentWeek: 'สัปดาห์ปัจจุบัน',
  today: 'วันนี้',
  shift: 'กะ',
  shifts: 'กะ',
  noShifts: 'ไม่กำหนดกะ',
  factoryStructure: 'โครงสร้างโรงงาน',
  asset: {
    globalCounter: 'นับทั่วโลก', localCounter: 'นับในระดับท้องถิ่น', waterCounter: 'นับน้ำ', valvePosition: 'ตำแหน่งวาล์ว', waterLevel: 'ระดับน้ำ', waterFlow: 'อัตราการไหลของน้ำ', pumpBalance: 'สมดุลของปั้ม',
  },
  wall: {
    comment: 'ความคิดเห็น', comments: 'ความคิดเห็น', vision: 'วิสัยทัศน์', downtimeEditorSettings: 'การตั้งค่าเครื่องมือแก้ไขเวลาหยุดการทำงาน',
  },
  menu: {
    monitoring: 'การตรวจสอบ', reports: 'รายงาน', overview: 'ภาพรวม', andon: 'ระบบอันดอน', weeklyAnalysis: 'การวิเคราะห์รายสัปดาห์', scoreAnalysis: 'การวิเคราะห์คะแนน', settings: 'การตั้งค่า', userSettings: 'การตั้งค่าบัญชี', notifications: 'การแจ้งเตือน', language: 'ภาษา', user: 'ผู้ใช้งาน', setAsHome: 'ตั้งเป็นหน้าหลัก', setFullScreen: 'ทำให้เต็มหน้าจอ', logout: 'ออกจากระบบ', loadMore: 'โหลดเพิ่มเติม', selectPlant: 'เลือกโรงงาน', activities: 'กิจกรรม', login: 'เข้าสู่ระบบ', preview: 'แสดงตัวอย่าง', lineGraph: 'กราฟเส้นผลิต', machineGraph: 'กราฟเครื่องจักร', homePageDevice: { title: 'หน้าหลักสำหรับอุปกรณ์นี้', description: 'หน้าจอนี้จะแสดงเสมอหลังจากเข้าสู่ระบบในอุปกรณ์นี้' }, homePageUser: { title: 'หน้าหลักสำหรับบัญชีของคุณ', description: 'หน้าจอนี้จะแสดงหลังจากเข้าสู่ระบบหากอุปกรณ์ไม่มีหน้าหลักอื่นๆ' },
  },
  import: {
    upload: 'วางไฟล์ที่นี่เพื่ออัปโหลด',
    notSaved: 'ยังไม่บันทึก',
    noChanges: 'ไม่มีการเปลี่ยนแปลง',
    saved: 'บันทึกแล้ว',
    dataSaved: 'บันทึกข้อมูลเรียบร้อยแล้ว',
    multiplierIsInvalid: 'ตัวคูณขัดแย้งกับการแปลงที่กำหนดไว้แล้ว',
    multiplierIsLessOrEqualZero: 'ตัวคูณต้องไม่น้อยกว่าหรือเท่ากับศูนย์',
    actionRequired: 'จำเป็นต้องดำเนินการ',
    checked: 'ตรวจสอบแล้ว',
    fillAndAdd: 'กรอกและเพิ่ม',
    chooseImage: 'เลือกรูปภาพ',
    nothingImported: 'ไม่มีข้อมูลที่ถูกต้องสำหรับการนำเข้า',
    previousImports: 'การนำเข้าก่อนหน้า',
    fileIsBeingProcessed: 'ไฟล์กำลังประมวลผล จะส่งการแจ้งเตือนเมื่อพร้อม',
    groupSuccessfullyAssign: 'กำหนดให้กับกลุ่มเรียบร้อยแล้ว',
    groupFailedToAssign: 'ไม่สามารถกำหนดให้กับกลุ่มได้',
    groupSuccessfullyRemoved: 'ลบออกจากกลุ่มเรียบร้อยแล้ว',
    groupFailedToRemove: 'ไม่สามารถลบออกจากกลุ่มได้',
    seeTemplates: 'ดูเทมเพลต',
    fileReview: 'ตรวจสอบไฟล์',
    templates: 'เทมเพลต',
    addTemplate: 'เพิ่มเทมเพลต',
    editTemplate: 'แก้ไขเทมเพลต',
    import: 'นำเข้า',
    uploadFile: 'อัปโหลดไฟล์',
    template: 'เทมเพลต',
    toUploadFilePickTemplate: 'เพื่ออัปโหลดไฟล์เลือกเทมเพลต',
    result: 'ผลลัพธ์',
    testFile: 'ไฟล์ทดสอบ',
    toSeeResultUploadTestFile: 'เพื่อดูผลลัพธ์ อัปโหลดไฟล์ทดสอบ',
    toTestFileSaveChanges: 'เพื่อทดสอบไฟล์ บันทึกการเปลี่ยนแปลงของคุณ',
    visible: 'ปรากฏ',
    saveFunction: 'บันทึกฟังก์ชัน',
    key: 'คีย์',
    value: 'ค่า',
    oldValue: 'ค่าเดิม',
    newValue: 'ค่าใหม่',
    unchanged: 'ไม่มีการเปลี่ยนแปลง',
    status: {
      applied: 'สำเร็จ', appliedWithErrors: 'ใช้งานโดยมีข้อผิดพลาด', scheduled: 'ตามกำหนด', faulted: 'มีข้อผิดพลาด', processing: 'กำลังประมวลผล',
    },
  },
  audit: { log: 'บันทึกการตรวจสอบ' },
  work: {
    event: 'ปัญหา', events: 'ปัญหาทั้งหมด', state: 'สถานะ', states: 'สถานะทั้งหมด', systemStates: 'สถานะของระบบ', reason: 'เหตุผล', reasons: 'เหตุผลทั้งหมด', correctiveAction: 'การแก้ไข', correctiveActions: 'การแก้ไขทั้งหมด', downtime: 'เวลาหยุดงาน', downtimes: 'เวลาหยุดงานทั้งหมด', wiki: 'บทความวิกิ', disconnected: 'ยกเลิกการเชื่อมต่อ', rootCause: 'สาเหตุหลัก', detachRootCause: 'ลบสาเหตุหลัก', rootMachine: 'เครื่องจักรที่เป็นสาเหตุหลัก', spectrum: 'ขอบเขตของงาน', downtimeList: 'รายการเวลาหยุดงาน', default: 'ค่าเริ่มต้น', tags: 'แท็ก', addTags: 'เพิ่มแท็ก', addSelected: 'เพิ่มที่เลือก', plannedDowntimes: 'เวลาหยุดงานที่วางแผน', unplannedDowntimes: 'เวลาหยุดงานที่ไม่ได้วางแผน', workTime: 'ระยะเวลาในสถานะการทำงาน', actionTaken: 'การดำเนินการแก้ไขที่ถูกทำ', noOngoingOrder: 'ไม่มีคำสั่งที่กำลังดำเนินการ', noOngoingShift: 'ไม่มีกะทำงานที่กำลังดำเนินการ', updateQueued: 'รายการเวลาหยุดงานที่อัปเดตแล้ว อาจใช้เวลาสักครู่', overrideQueued: 'รายการเวลาหยุดงานที่เพิ่มแล้ว อาจใช้เวลาสักครู่', noForcedState: "ไม่มีปัญหาที่กำหนดด้วยแท็ก 'Forced' โปรดเพิ่มการกำหนดเวลาหยุดงานด้วยแท็กนี้เพื่อหยุดเครื่องหรือเส้นการผลิต", downtimeSince: 'เวลาหยุดงานตั้งแต่', lasting: 'ที่ยาวนาน',
  },
  general: {
    name: 'ชื่อ',
    from: 'จาก',
    search: 'ค้นหา',
    max: 'สูงสุด',
    errors: 'ข้อผิดพลาด',
    min: 'ต่ำสุด',
    noResults: 'ไม่มีผลลัพธ์',
    title: 'หัวข้อ',
    description: 'คำอธิบาย',
    fromStart: 'จากจุดเริ่มต้น',
    confirm: 'ยืนยัน',
    tryAgain: 'ลองอีกครั้ง',
    to: 'ถึง',
    toEnd: 'จนถึงจุดสิ้นสุด',
    finish: 'เสร็จสิ้น',
    add: 'เพิ่ม',
    all: 'ทั้งหมด',
    clear: 'ล้างค่า',
    hidden: 'ซ่อน',
    remove: 'ลบ',
    inherited: 'สืบทอด',
    detach: 'ถอดตัว',
    attach: 'แนบ',
    close: 'ปิด',
    cancel: 'ยกเลิก',
    refresh: 'รีเฟรช',
    lastRefresh: 'รีเฟรชครั้งล่าสุด: {0} ที่ผ่านมา',
    reset: 'รีเซ็ต',
    edit: 'แก้ไข',
    event: 'เหตุการณ์',
    details: 'รายละเอียด',
    collapseDetails: 'ย่อรายละเอียด',
    summary: 'สรุป',
    save: 'บันทึก',
    change: 'เปลี่ยนแปลง',
    noData: 'ไม่มีข้อมูล',
    nothingDefined: 'ไม่ได้กำหนดอะไร',
    others: 'อื่นๆ',
    back: 'กลับ',
    next: 'ถัดไป',
    results: 'ผลลัพธ์',
    selected: 'ที่เลือก',
    allSelected: 'เลือกทั้งหมด',
    unchecked: 'ไม่ได้เลือก',
    selectAll: 'เลือกทั้งหมด',
    createNew: 'สร้างใหม่',
    useExisting: 'ใช้ที่มีอยู่',
    select: 'เลือก',
    saveSuccessed: 'บันทึกสำเร็จ',
    saveFailed: 'บันทึกล้มเหลว',
    shouldArchive: 'ควรเก็บถาวร',
    areYouSure: 'คุณแน่ใจไหม?',
    manHours: 'ชั่วโมงการทำงาน',
    view: 'แสดง',
    yes: 'ใช่',
    no: 'ไม่',
    reason: 'เหตุผล',
    actions: 'การดำเนินการ',
    reasonUnknown: 'เหตุผลไม่ทราบ',
    forcedByOperator: 'บังคับโดยผู้ประกอบการ',
    type: 'ประเภท',
    valueType: 'ประเภทของค่า',
    value: 'ค่า',
    unit: 'หน่วย',
    disable: 'ปิดการใช้งาน',
    disabled: 'ปิดการใช้งานแล้ว',
    disabledShe: 'ปิดการใช้งานแล้ว',
    inactive: 'ไม่ใช้งาน',
    enable: 'เปิดใช้งาน',
    enabled: 'เปิดใช้งานแล้ว',
    enabledShe: 'เปิดใช้งานแล้ว',
    ignore: 'เพิกเฉย',
    cancelled: 'ยกเลิก',
    nominal: 'ค่ามาตรฐาน',
    unsavedChanges: 'คุณต้องการออกจากหน้านี้หรือไม่? คุณมีการเปลี่ยนแปลงที่ยังไม่ได้บันทึก!',
    now: 'ตอนนี้',
    showAll: 'แสดงทั้งหมด',
    showMore: 'แสดงเพิ่มเติม',
    continue: 'ดำเนินการต่อ',
    group: 'กลุ่ม',
    download: 'ดาวน์โหลด',
    progress: 'ความคืบหน้า',
    dates: 'วันที่',
    pickDate: 'เลือกวันที่',
    dir: {
      top: 'ด้านบน', bottom: 'ด้านล่าง', left: 'ด้านซ้าย', right: 'ด้านขวา',
    },
    sourceURI: 'ที่มา URI',
    dimensions: 'มิติ',
    status: 'สถานะ',
    code: 'รหัส',
    start: 'เริ่ม',
    end: 'สิ้นสุด',
    update: 'อัปเดต',
    deviceId: 'รหัสอุปกรณ์',
    time: 'เวลา',
    show: 'แสดง',
    hide: 'ซ่อน',
    last: 'ล่าสุด',
    recent: 'ล่าสุด',
    requestReceived: 'ได้รับคำขอแล้ว',
    deleted: 'ลบแล้ว',
    filters: 'ตัวกรอง',
    total: 'ทั้งหมด',
    restoreDefaults: 'กู้คืนค่าเริ่มต้น',
    setDate: 'ตั้งค่าวันที่',
    setTime: 'ตั้งค่าเวลา',
    line: 'สายผลิต',
    option: 'ตัวเลือก',
    default: 'ค่าเริ่มต้น',
    set: 'ตั้งค่า',
    percent: 'เปอร์เซ็นต์',
  },
  machineControl: {
    turnOn: 'เปิด', turnOff: 'ปิด', current: 'ปัจจุบัน', liveStream: 'สตรีมสด', disconnectedWarning: 'คำเตือน! เครื่องจักรถูกตัดการเชื่อมต่ออยู่ในขณะนี้ - การปิดอาจทำให้ข้อมูลที่อยู่ในบัฟเฟอร์ขาดหายไป', startMachine: 'เริ่มเครื่องจักร <b>{machine}</b>?',
  },
  lineControl: { startLine: 'เริ่มสายผลิต <b>{line}</b>?', stop: 'หยุด', start: 'เริ่ม' },
  time: {
    week: 'สัปดาห์', minutes: 'นาที', date: 'วันที่', day: 'วัน', hour: 'ชั่วโมง', hours: 'ชั่วโมง', hoursPlural: 'ชั่วโมง', days: 'วัน', month: 'เดือน', year: 'ปี', quarter: 'ไตรมาส', resolution: 'ความละเอียด', duration: 'ระยะเวลา', seconds: 'วินาที', startDate: 'วันที่เริ่ม', endDate: 'วันที่สิ้นสุด', startTime: 'เวลาเริ่ม', endTime: 'เวลาสิ้นสุด', selectDay: 'เลือกวัน', longerThan: 'นานกว่า', shorterThan: 'สั้นกว่า', scope: 'ขอบเขตเวลา', currentOrder: 'คำสั่งปัจจุบัน', showMinorStops: 'แสดงการหยุดเล็กน้อย', plannedOnly: 'แสดงเฉพาะที่วางแผน', unplannedOnly: 'แสดงเฉพาะที่ไม่ได้วางแผน', performanceOnly: 'ความสูญเสียประสิทธิภาพ', availabilityOnly: 'ความสูญเสียความพร้อมใช้งาน', utilizationOnly: 'ความสูญเสียการใช้งาน', excludeDefaults: 'ซ่อนค่าเริ่มต้น', monday: 'วันจันทร์', tuesday: 'วันอังคาร', wednesday: 'วันพุธ', thursday: 'วันพฤหัสบดี', friday: 'วันศุกร์', saturday: 'วันเสาร์', sunday: 'วันอาทิตย์', plannedDate: 'วันที่วางแผน', custom: 'กำหนดเอง',
  },
  graph: {
    flow: 'กระแส', flows: 'กระแส', production: 'กระแสการผลิต', physical: 'ทางกายภาพ', supplying: 'การจัดหาอุปกรณ์', archiveChanges: 'เก็บสถานะการเปลี่ยนแปลง', isActive: 'ทำงานอยู่', addElement: 'เพิ่มองค์ประกอบ', detached: 'แยก', andon: 'อานดอน', noActiveFlow: 'ไม่มีกระแสที่กำลังทำงาน',
  },
  production: { rawCounterIncreases: 'ค่านับข้อมูลเชิงสรุปในช่วงเวลานี้' },
  monitoring: {
    ofThePlan: 'คุณได้ถึง %{value}% ของค่านี้',
    noPlan: 'ไม่มีแผน',
    performanceSettingHistory: 'ประวัติการตั้งค่าประสิทธิภาพ',
    unitConversionsHistory: 'ประวัติการแปลงหน่วย',
    averageTargetPerformance: 'ประสิทธิผลเฉลี่ยเป้าหมาย',
    reportParam: 'การกำหนดพารามิเตอร์รายงาน',
    performanceType: 'ประเภทประสิทธิภาพ',
    designSpeed: 'การออกแบบ',
    validatedSpeed: 'ตรวจสอบแล้ว',
    targetProduction: 'เป้าหมายการผลิต',
    maxPerfProduction: 'ประสิทธิภาพสูงสุด',
    plannedFromOrders: 'คำสั่งที่วางแผนไว้',
    planned: 'ที่วางแผน',
    notInFlow: 'ไม่อยู่ในกระแสการผลิต',
    produced: 'ผลิต',
    wasted: 'สูญเสีย',
    lastMessage: 'ข้อความล่าสุด',
    noMessages: 'ไม่มีข้อความ',
    noAlarms: 'ไม่มีการเตือน',
    noConnectionInfo: 'ไม่มีข้อมูลเกี่ยวกับการเชื่อมต่อ',
    noConnection: 'ไม่มีการเชื่อมต่อกับเซิร์ฟเวอร์',
    processing: 'กำลังประมวลผล',
    dataProcessingFromLast: 'กำลังประมวลผลข้อมูลจาก',
    lineStates: 'สถานะสายผลิต',
    disconnected: 'ตัดการเชื่อมต่อ',
    serverDisconnected: 'ตัดการเชื่อมต่อกับเซิร์ฟเวอร์',
    working: 'กำลังทำงาน',
    ready: 'พร้อม',
    notWorking: 'ในช่วงเวลาหยุด',
    productionProgress: 'ความคืบหน้าในการผลิต',
    production: 'การผลิต',
    goodCount: 'จำนวนสินค้าที่ผลิตได้ดี',
    wasteCount: 'จำนวนสินค้าที่สูญเสีย',
    productionMap: 'แผนผังการผลิต',
    workStates: 'สถานะการทำงาน',
    workLog: 'ประวัติการทำงาน',
    event: 'เหตุการณ์',
    events: 'เหตุการณ์',
    cause: 'สาเหตุ',
    causes: 'สาเหตุ',
    reasons: 'เหตุผล',
    warnings: 'คำเตือน',
    correctiveAction: 'การแก้ไขปัญหา',
    stopRealTime: 'หยุดเวลาจริง',
    stoppedRealTime: 'เวลาจริงหยุดทำงาน',
    realTime: 'เวลาจริง',
    toRealTime: 'ไปยังเวลาจริง',
    downtimes: 'เวลาหยุดการทำงาน',
    changeCurrentDowntime: 'เปลี่ยนเวลาหยุดการทำงาน',
    doubleClickToEdit: 'ดับเบิลคลิกเพื่อแก้ไขเวลาหยุดการทำงาน',
    percentShare: 'ส่วนแบ่งเป็นเปอร์เซ็นต์',
    timeShare: 'ส่วนแบ่งเวลา',
    minorStops: 'รวมถึงการหยุดเล็กน้อย',
    remainingPlannedProduction: 'การผลิตที่เหลือได้ตามความเร็วเฉลี่ยทางกายภาพ',
    remainingEstimatedProduction: 'การผลิตที่เหลือได้ตามความเร็วที่มีผล',
    remainingTime: 'เวลาที่เหลือ',
    performance: { short: 'ประสิทธิภาพล่าสุด {0}', effective: 'ประสิทธิภาพที่มีผล', nominal: 'ประสิทธิภาพเฉลี่ย' },
    segment: {
      baseQuantity: 'ปริมาณฐาน', baseQuality: 'คุณภาพฐาน', baseAvailability: 'ความพร้อมใช้งานฐาน', basePerformance: 'ประสิทธิภาพฐาน',
    },
    machine: {
      counter: 'เคาน์เตอร์', parameters: 'พารามิเตอร์', alarms: 'การเตือน', processParameters: 'พารามิเตอร์ของกระบวนการ', currentParameters: 'พารามิเตอร์ปัจจุบัน', activeAlarms: 'การเตือนที่ใช้งานอยู่', counters: 'เคาน์เตอร์', alarmsHoldups: 'การเตือนและการหยุด', performanceInfo: 'ประสิทธิภาพเฉลี่ยจากล่าสุด {0}', others: 'อื่น ๆ', lifespan: 'อายุการใช้งาน', environmentCondition: 'เงื่อนไขสภาพแวดล้อม', condition: 'เงื่อนไขทรัพย์สิน', cost: 'ต้นทุน', failurePreditcion: 'การพยากรณ์การล้มเหลว', probabilityFailure: 'ความน่าจะเป็นของการล้มเหลวในอีก 10 วัน', failureType: 'ประเภทของการล้มเหลว', timeToFailure: 'เวลาที่คาดการณ์ว่าจะเกิดการล้มเหลว', predictedFailure: 'การล้มเหลวที่คาดการณ์', maintenanceHistory: 'ประวัติการบำรุงรักษา',
    },
    lineInfo: {
      advices: 'เคล็ดลับ', forService: 'งาน', jobs: 'งาน', completed: 'งานที่เสร็จ', problems: 'ปัญหา', planned: 'งานที่รออยู่', toAchieveTarget: 'ปริมาณการผลิตที่คาดหวังในช่วง', confirmLinePause: 'ยืนยันการหยุดเส้นการผลิต',
    },
    worstAlarms: 'ปัญหาที่แย่ที่สุด',
    problems: 'ไม่มีปัญหา | ปัญหา 1 รายการ | ปัญหา {0} รายการ',
    overdue: 'เลยกำหนดเวลา {0}',
    left: 'เหลือ {0}',
  },
  components: {
    title: 'องค์ประกอบ', one: 'องค์ประกอบ', usagePerUnit: 'การใช้งานต่อหน่วย', required: 'จำเป็น', convertUnit: 'แปลงหน่วย', validation: 'จำเป็นต้องผ่านการตรวจสอบ', batchTracking: 'ติดตามชุดสินค้า', scanTrackingId: 'สแกนหมายเลขติดตาม', batchTrackingHelp: 'เมื่อเปิดใช้งานการติดตาม คุณจะต้องให้หมายเลขระบุชุดสำหรับแต่ละบรรจุภัณฑ์ที่สแกน', defaultPackageQuantity: 'ในบรรจุภัณฑ์', warningLevelPercentage: 'เปอร์เซ็นต์คำเตือน', warningLevel: 'ระดับการเตือน', warningLevelHelp: '% - เตือนเมื่อใช้งานบางส่วนของบรรจุภัณฑ์\r\nนาที - เตือนเมื่อเหลือเวลาประมาณนาทีที่ระบุ', scannerCode: 'รหัสสแกนเนอร์', scannerCodeType: 'ประเภทของรหัส', noTrackingId: 'ไม่มีรหัสการติดตาม', scan: 'สแกน', packages: 'บรรจุภัณฑ์', scanPackages: 'สแกนบรรจุภัณฑ์', noComponents: 'ไม่มีองค์ประกอบที่กำหนดไว้', invalidCode: 'ไม่พบองค์ประกอบ', addComponent: 'เพิ่มองค์ประกอบ', closed: 'ปิด', scanned: 'สแกนแล้ว', closeConfirm: 'ปิด', eta: 'เวลาที่คาดว่าจะมาถึง', active: 'กำลังใช้งาน', clickToActivate: 'คลิกเพื่อเปิดใช้งาน', used: 'ใช้งาน', estimatedTotalQuantity: 'ปริมาณที่คาดว่าจะต้องใช้', packageScannerCode: 'รหัสบรรจุภัณฑ์', defaultPackageQuantitySum: 'ปริมาณรวมในบรรจุภัณฑ์', registeredDate: 'วันที่สแกน', trackingId: 'รหัสการติดตาม', consumptionType: { title: 'ประเภทการใช้งาน', help: '"MULTIPLE" อนุญาตให้เปิดใช้งานบรรจุภัณฑ์หลายรายการพร้อมกัน. "SINGLE" ปิดบรรจุภัณฑ์ก่อนหน้าโดยอัตโนมัติเมื่อเปิดใช้งานใหม่' },
  },
  oee: {
    oee: 'OEE (Overall Equipment Efficiency)', oeePercentage: 'OEE [%]', oeeLoss: 'การสูญเสียใน OEE', availability: 'ความพร้อมใช้งาน', availabilityPercentage: 'ความพร้อมใช้งาน [%]', performance: 'ประสิทธิภาพ', performancePercentage: 'ประสิทธิภาพ [%]', quality: 'คุณภาพ',
  },
  metrics: {
    teep: 'TEEP (Total Effective Equipment Performance)', mtbf: 'เวลาเฉลี่ยระหว่างครั้งล้มเหลว (MTBF)', mttr: 'เวลาเฉลี่ยในการซ่อมแซม (MTTR)', mtbm: 'เวลาเฉลี่ยระหว่างการบำรุงรักษา (MTBM)', reliabilityMetrics: 'ตัวชี้วัดความน่าเชื่อถือ',
  },
  energy: {
    usedEnergy: 'พลังงานที่ใช้', currentLeastEfficient: 'เครื่องจักรที่มีประสิทธิภาพต่ำที่สุด', currentPower: 'พลังงานปัจจุบัน', baseline: 'ข้อมูลเริ่มต้น', max: 'ค่าเฉลี่ยสูงสุด',
  },
  items: {
    items: 'รายการ', item: 'รายการ', import: 'นำเข้ารายการ', itemGroups: 'กลุ่มรายการ', itemGroup: 'กลุ่มรายการ', inheritedFromGroup: 'ถูกสืบทอดมาจากกลุ่ม', lineConfiguration: 'การกำหนดค่าเส้นการผลิต', noLineConfigured: 'ไม่มีผลิตภัณฑ์ที่กำหนดค่าสำหรับเส้นการผลิตนี้', groups: 'กลุ่ม', add: 'เพิ่มรายการ', addGroup: 'เพิ่มกลุ่ม', new: 'รายการใหม่', edit: 'แก้ไขรายการ', number: 'หมายเลข', description: 'รายละเอียด', quantity: 'ปริมาณ/พาเลต', unit: 'หน่วยการนับ', performance: 'ประสิทธิภาพ', expectedPerformance: 'ประสิทธิภาพที่คาดหวัง', expectedChangeover: 'ประสิทธิภาพที่คาดหวัง', packingStructure: 'โครงสร้างการบรรจุภัณฑ์', groupPackingStructure: 'โครงสร้างการบรรจุภัณฑ์ของกลุ่ม', itemRoutingSpeed: 'ความเร็วในการเดินทางของรายการ', groupRoutingSpeed: 'ความเร็วในการเดินทางของกลุ่มรายการ', components: 'องค์ประกอบ', bulkDeleteWarning: 'คุณแน่ใจว่าต้องการลบผลิตภัณฑ์ที่เลือก?', bulkDeleteConfirm: 'ลบผลิตภัณฑ์ที่เลือก', additionalFields: 'ฟิลด์เพิ่มเติม', noAdditionalFields: 'ไม่มีฟิลด์เพิ่มเติม',
  },
  pageNotFoundExplanation: 'เราไม่พบหน้านี้ ขออภัยในความไม่สะดวก',
  processParams: {
    compositionName: 'ชื่อส่วนประกอบ', compositions: 'ส่วนประกอบ', saveComposition: 'บันทึกส่วนประกอบ', signals: 'สัญญาณ', signalName: 'ชื่อสัญญาณ', signalValue: 'ค่าสัญญาณ', ongoingState: 'สถานะที่กำลังดำเนินการ', ongoingProblem: 'ปัญหาที่กำลังดำเนินการ', ongoingOrder: 'คำสั่งที่กำลังดำเนินการ', problemStart: 'เริ่มต้นปัญหา', problemEnd: 'สิ้นสุดปัญหา', orderStart: 'เริ่มคำสั่งผลิต', orderEnd: 'สิ้นสุดคำสั่งผลิต', orderProduction: 'การผลิตจากคำสั่งผลิต',
  },
  healthcheck: { noDriverConnection: 'ไม่มีการเชื่อมต่อกับไดร์เวอร์' },
  vision: {
    vision: 'วิสัยทัศน์', showAllClips: 'แสดงคลิปทั้งหมด', selectCamera: 'เลือกกล้อง', getClip: 'รับคลิป', getTheTwoPreviousMinutes: 'รับคลิป 2 นาทีก่อนและ 2 นาทีหลังจากเวลาเริ่มเวลาหยุดงาน', noClips: 'ไม่พบคลิป', noRecords: 'กล้องไม่มีบันทึกจากวันนั้นสำหรับดาวน์โหลด', currentVideoTime: 'เวลาวิดีโอปัจจุบัน', startVideoTime: 'เวลาเริ่มวิดีโอ', startDowntime: 'เริ่มเวลาหยุดงาน', endDowntime: 'สิ้นสุดเวลาหยุดงาน', showLiveVideo: 'แสดงวิดีโอสดจากกล้อง', selectStartClip: 'เลือกวิดีโอเริ่มต้น', selectEndClip: 'เลือกวิดีโอสิ้นสุด', videoDurationIs: 'ระยะเวลาของวิดีโอ', invalidTimeRange: 'ช่วงเวลาไม่ถูกต้อง', toMoreBefore: 'เลือกวันที่เริ่มต้นก่อนสำหรับวิดีโอนี้', toMoreAfter: 'เลือกวันที่สิ้นสุดล่างสุดสำหรับวิดีโอนี้', maxVideoIs: 'ความยาวของวิดีโอสูงสุด', auto: 'มาก', autoLong: 'ร้องขอวิดีโอโดยอัตโนมัติจากระบบ', manual: 'มือ', manualLong: 'ร้องขอวิดีโอด้วยตนเอง', videoTrigger: 'เมื่อเลือก แท็ก VideoTrigger จะถูกกำหนดค่าสำหรับประเภทปัญหานี้',
    autoDownload: 'ขอให้ดาวน์โหลดวิดีโอสำหรับทุกรายการที่เกิดขึ้นในอนาคตของประเภทนี้',
    watchVideo: 'ดูวิดีโอ', clipIsNotReadyYet: 'คลิปวิดีโอยังไม่พร้อมใช้งาน',
  },
  downloadStatus: {
    failed: 'ล้มเหลว', inProgress: 'กำลังดำเนินการ', success: 'พร้อมใช้งาน', failedOnEdge: 'กล้องเสีย', noArchiveRecordings: 'กล้องไม่มีการบันทึก', deleted: 'ลบแล้ว',
  },
  quests: 'งาน',
  quest: {
    quest: 'งาน', questTitle: 'หัวข้องาน', questDescription: 'รายละเอียดงาน', project: 'โครงการ', type: 'ประเภทงาน', state: 'สถานะงาน', closeToState: 'ใกล้สถานะ', assignToGroups: 'กำหนดกลุ่ม', taskDetails: 'รายละเอียดงาน', files: 'ไฟล์', comments: 'ความคิดเห็น', noFiles: 'ไม่มีไฟล์',
  },
  health: { health: 'สุขภาพ', healthHistory: 'ประวัติสุขภาพ' },
  panel: {
    number: 'หมายเลข', sku: 'รหัสสินค้า', selectState: 'เลือกสถานะ', selectMachine: 'เลือกเครื่องจักร', comment: 'ความคิดเห็น', downtimeFrom: 'หยุดงานจาก', ongoing: 'กำลังดำเนินการ', averagePerformance: 'ประสิทธิภาพเฉลี่ย', currentPerformance: 'ประสิทธิภาพปัจจุบัน', currentLineStatus: 'สถานะเครื่องผลิตปัจจุบัน', provideReasonAndComment: 'เพิ่มเหตุผลและความคิดเห็น', commentPlaceholder: 'เขียนความคิดเห็นของคุณ', confirmData: 'ยืนยันข้อมูล', inputPlaceholder: 'เขียนที่นี่',
  },
  workCalendar: 'ปฏิทินการทำงาน',
  schedule: 'กำหนดการ',
  importSchedule: 'นำเข้ากำหนดการ',
  addSchedule: 'เพิ่มกำหนดการ',
  repeatEvery: 'ทำซ้ำทุก',
  repeatOn: 'ทำซ้ำเมื่อ',
  ends: 'สิ้นสุด',
  starts: 'เริ่มต้น',
  never: 'ไม่เคย',
  on: 'เปิด',
  calendar: { period: 'ระยะเวลา' },
  cycle: 'วงจร',
  deleteRecurringInstance: 'ลบการเกิดซ้ำ',
  editRecurringInstance: 'แก้ไขการเกิดซ้ำ',
  thisInstance: 'ส่วนตัวนี้',
  thisAndFollowingInstances: 'ส่วนตัวนี้และต่อไป',
  allInstances: 'ทุกส่วนตัว',
  order: {
    addNewProperty: 'เพิ่มคุณสมบัติใหม่', sortByDate: 'เรียงตามวันที่', sortBy: 'เรียงตาม', ascending: 'จากน้อยไปมาก', descending: 'จากมากไปน้อย', quantityProduced: 'ปริมาณผลิต', plannedProduction: 'การผลิตที่วางแผน', endDate: 'วันที่สิ้นสุด', activatedDate: 'วันที่เปิดใช้งาน', totalTime: 'ระยะเวลาของคำสั่งผลิต', plannedDate: 'วันที่เริ่มต้น', eta: 'ETA', delete: 'เคลียร์ตัวกรอง',
  },
  noCycle: 'ไม่มีการกำหนดวงจร',
  users: { firstName: 'ชื่อ', lastName: 'นามสกุล' },
  teams: { teamName: 'ชื่อทีม' },
  schedules: { addLine: 'เพิ่มเส้นในตัวกรอง', clearLines: 'เคลียร์เส้นทั้งหมด' },
  chart: { weekSymbol: 'W' },
  taxonomies: {
    taxonomy: 'จำแนกหมวดหมู่', classification: 'การจำแนก', selectClassification: 'เลือกการจำแนก', selectClassificationLevel: 'เลือกระดับการจำแนก', selectClassificationNodes: 'เลือกโหนดการจำแนก', defaultTaxonomy: 'ค่าเริ่มต้น', pickCategory: 'เลือกหมวดหมู่', selectTaxonomy: 'เลือกแผนการจัดหมวดหมู่', selectTaxonomyLevel: 'เลือกระดับการจัดหมวดหมู่',
  },
  andon: {
    top3Downtimes: 'อันดับ 3 ของเวลาหยุดงานที่ยาวที่สุด', todayOeeTrend: 'แนวโน้ม OEE วันนี้', stateDistribution: 'การกระจายสถานะ', thisWeekOeeTrend: 'แนวโน้ม OEE ในสัปดาห์นี้', currentState: 'สถานะปัจจุบัน', noActiveOrder: 'ไม่มีคำสั่งผลิตที่กำลังดำเนินการ',
  },
};
